var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5 12H18","stroke":"#1E6980","strokeWidth":"1.5","strokeLinecap":"square","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12 5L19 12L12 19","stroke":"#1E6980","strokeWidth":"1.5","strokeLinecap":"square","key":1})]);
}

Arrow.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
